export const agileInNumbersCards = ['93%', '44%', '70%', '100%'];
